import {FOOTER_CHANGE_STATUS_TEXT, FOOTER_TOGGLE_STATUS_TEXT} from "../constants/ActionTypes";

const initialState = {
  statusText: ''
};

export default function FooterReducer(state = initialState, action) {
  switch (action.type) {
    case FOOTER_CHANGE_STATUS_TEXT:
      return {
        ...state,
        statusText: action.value
      };

    case FOOTER_TOGGLE_STATUS_TEXT:
      return {
        ...state,
        show: action.show
      };

    default:
      return state;
  }
}
